import {Grid, MenuItem, TextField, Typography} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
  AccountProcessingThresholdKey,
  DEFAULT_LAST_PROCESSING_INACTIVITY_DAYS,
  SubscriptionConfigView,
  UserRoles,
  useUserInfo,
} from '@ozark/common';

const DayOptions: number[] = [3, 7, 14, 30];
interface Props {
  subscriptionConfig: SubscriptionConfigView | undefined;
  onThresholdChanged: (days: number) => Promise<void>;
}

export const ProcessingStoppedDaysTableRow = ({subscriptionConfig, onThresholdChanged}: Props) => {
  const {role} = useUserInfo();
  if (role !== UserRoles.agent) {
    return <></>;
  }
  return (
    <TableRow>
      <TableCell colSpan={3}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6} pl="32px!important" pt="0px!important">
            <Typography variant="body2">Stopped Processing Alert Threshold</Typography>
          </Grid>
          <Grid item xs={6} pt="0px!important">
            <TextField
              margin="normal"
              variant="standard"
              fullWidth
              select
              onChange={e => onThresholdChanged(+e.target.value)}
              value={
                subscriptionConfig?.[AccountProcessingThresholdKey] ??
                DEFAULT_LAST_PROCESSING_INACTIVITY_DAYS
              }
              sx={{textAlign: 'center'}}
            >
              {DayOptions.map(x => (
                <MenuItem value={x}>{`${x} Days`}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} pl="32px!important" pt="0px!important">
            <Typography variant="subtitle2">
              {`An automated email/notification will be sent to you when one of your merchants have stopped processing within the set threshold`}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};
